module.exports = __webpack_public_path__ + "media/offers_icons/dostawcze-blue-179cc73d.svg";